<template>
  <div :class="[noBorder && 'no-bottom-border', 'listItem']">
    <div :class="[isNext ? 'minileft' : 'left']">
      <img
        :src="item.memberHeadUrl"
        class="memberHeader"
        v-if="item.memberHeadUrl"
      />
      <img
        src="@/assets/images/default-header.png"
        class="memberHeader"
        v-else
      />
    </div>
    <div class="right">
      <p class="nickName">{{ item.memberName }}</p>
      <p class="conText">{{ item.content }}</p>
      <!-- 图片 -->
      <div v-if="item.fileList && item.fileList.length > 0" class="img">
        <div
          :class="[
            'img-item',
            index === 0 && 'left-marg',
            index === 3 && 'right-marg',
            isNext && 'img-item-mini',
          ]"
          v-for="(value, index) in item.fileList.slice(0, 4)"
        >
          <div class="inner">
            <img :src="value.path" alt="" class="item-img" />
          </div>
          <span class="img-count" v-if="index === 3">{{
            `共${item.fileList.length}张`
          }}</span>
        </div>
      </div>
      <!-- 赞 -->
      <div class="time-laud">
        <span class="time">{{ item.createTime }}</span>
        <div class="laud-coment">
          <div class="commentwrap">
            <img
              src="@/assets/images/icon_comment.png"
              alt=""
              class="comment-img"
            />
            <span class="comment-text" v-if="item.ccount">{{
              item.ccount
            }}</span>
          </div>
          <div class="laudwrap">
            <img
              src="@/assets/images/icon_like_a.png"
              alt=""
              class="laud-img"
              v-if="item.ifLaud"
            />
            <img
              src="@/assets/images/icon_like.png"
              alt=""
              class="laud-img"
              v-else
            />
            <span class="laud-text" v-if="item.lcount">{{ item.lcount }}</span>
          </div>
        </div>
      </div>
      <!--二级评论列表 slot -->
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      require: true,
    },
    isNext: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="less" scoped>
.listItem {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0;
  .left {
    width: 50px;
    .memberHeader {
      width: 40px;
      height: 40px;
      border-radius: 20px;
    }
  }
  .minileft {
    width: 40px;
    .memberHeader {
      width: 30px;
      height: 30px;
      border-radius: 20px;
    }
  }
  .right {
    flex: 1;
    .nickName {
      font-size: 14px;
      font-weight: 600;
      color: #515151;
    }
    .conText {
      font-size: 14px;
      margin-top: 6px;
    }
    .img {
      margin-top: 6px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      .img-item {
        width: 25%;
        padding: 0 2px;
        position: relative;
        .inner {
          position: relative;
          height: 100%;
          width: 100%;
          border-radius: 10px;
          padding-top: 100%;
          overflow: hidden;
        }
        .item-img {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
        .img-count {
          width: 50px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          border-radius: 20px;
          font-size: 12px;
          position: absolute;
          z-index: 9;
          left: 50%;
          top: 50%;
          margin-left: -25px;
          margin-top: -12px;
          color: #fff;
          background-color: rgba(0, 0, 0, 0.5);
        }
      }
      .img-item-mini {
        height: 60px !important;
      }
      .left-marg {
        padding-left: 0 !important;
      }
      .right-marg {
        padding-right: 0 !important;
      }
    }

    //
    .time-laud {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .time {
        font-size: 12px;
        color: #9e9e9e;
      }
      .laud-coment {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
        .commentwrap {
          display: flex;
          align-items: center;
          .comment-img {
            width: 20px;
            height: 20px;
            flex-shrink: 0;
          }
          .comment-text {
            flex: 1;
          }
        }
        .laudwrap {
          display: flex;
          align-items: center;
          margin-left: 20px;
          .laud-img {
            width: 20px;
            height: 20px;
            flex-shrink: 0;
          }
          .laud-text {
            flex: 1;
          }
        }
        .laud-text,
        .comment-text {
          font-size: 14px;
          color: #9e9e9e;
          margin-left: 4px;
        }
      }
    }
  }
}
.no-bottom-border {
  border-bottom: none !important;
}
</style>
